import { render, staticRenderFns } from "./form-mail.vue?vue&type=template&id=5ec003f2&scoped=true&"
import script from "./form-mail.vue?vue&type=script&lang=js&"
export * from "./form-mail.vue?vue&type=script&lang=js&"
import style0 from "./form-mail.vue?vue&type=style&index=0&id=5ec003f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec003f2",
  null
  
)

export default component.exports